import React, { PropsWithChildren, ReactNode } from 'react'
import {
  Box as BodyBox,
  Box as ContainerBox,
  Box as HeaderBox,
  Box as RoundedBox,
} from '@node-space/ui-components'
import { FullScreenLayout } from './FullScreenLayout'
import { PoweredByBvnk } from './PoweredByBvnk'

export interface PublicPageLayoutProps extends PropsWithChildren {
  header?: ReactNode
  footer?: ReactNode
}

export const PublicPageLayout = ({ header, children, footer }: PublicPageLayoutProps) => {
  return (
    <FullScreenLayout padding={24} className="md:p-10">
      <ContainerBox flexCol gap={12} align="center" width="full" className="max-w-[880px]">
        <PoweredByBvnk />
        <RoundedBox width="full" className="bg-sidebar rounded-2xl overflow-hidden">
          {header && (
            <HeaderBox paddingX={32} className="py-[72px] md:p-[60px] relative">
              {header}
            </HeaderBox>
          )}
          <BodyBox
            flexCol
            gap={24}
            padding={32}
            className="bg-surface-interactive md:px-[60px] md:pb-12 md:pt-10"
          >
            {children}
          </BodyBox>
        </RoundedBox>
        {footer && (
          <p className="text-body-regular-small text-center text-foreground-subdued">{footer}</p>
        )}
      </ContainerBox>
    </FullScreenLayout>
  )
}
